module.exports = __webpack_public_path__ + "img/login.48c8e892.png";